export const LoadingIndicatorMessages = {
  message: {
    id: 'loadingIndicator.Text.Loading',
    defaultMessage: 'Loading...',
  },
};
